import { render } from "./ProfileCardDropDown.vue?vue&type=template&id=596b85f9"
import script from "./ProfileCardDropDown.vue?vue&type=script&lang=js"
export * from "./ProfileCardDropDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__